// extracted by mini-css-extract-plugin
export default {"container":"NotFoundPage_container__GVOOg","title":"NotFoundPage_title__Lu3S7","message":"NotFoundPage_message__tYBdZ","btnPrimary":"NotFoundPage_btnPrimary__Vilj+"};